import api from "./axiosConfig";
import { DisputeItem } from "../types";

export type CreateDisputeRequest = Omit<DisputeItem, "id" | "tenantId" | "clientId">;
export type UpdateDisputeRequest = Omit<DisputeItem, "id" | "tenantId" | "clientId" | "createdAt">;

export const disputesApi = {
  getAllForClient: async (clientId: string): Promise<DisputeItem[]> => {
    const response = await api.get<DisputeItem[]>(`/clients/${clientId}/disputes`);
    return response.data;
  },

  getById: async (clientId: string, disputeId: string): Promise<DisputeItem> => {
    const response = await api.get<DisputeItem>(`/clients/${clientId}/disputes/${disputeId}`);
    return response.data;
  },

  create: async (clientId: string, payload: CreateDisputeRequest): Promise<DisputeItem> => {
    const response = await api.post<DisputeItem>(`/clients/${clientId}/disputes`, payload);
    return response.data;
  },

  update: async (
    clientId: string,
    disputeId: string,
    payload: UpdateDisputeRequest
  ): Promise<DisputeItem> => {
    const response = await api.put<DisputeItem>(`/clients/${clientId}/disputes/${disputeId}`, payload);
    return response.data;
  },

  remove: async (clientId: string, disputeId: string): Promise<void> => {
    await api.delete(`/clients/${clientId}/disputes/${disputeId}`);
  },
};
